import { render } from "./EmptyCard.vue?vue&type=template&id=18e5a032&scoped=true"
import script from "./EmptyCard.vue?vue&type=script&lang=js"
export * from "./EmptyCard.vue?vue&type=script&lang=js"

import "./EmptyCard.vue?vue&type=style&index=0&id=18e5a032&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e5a032"]])

export default __exports__